import React from 'react'
import skinToggle from '../../../util/skinToggle.js'

function toggleFooter () {
  let skinQueryParam = window.location.href.toLowerCase().match(/skin=([^&]*)/i)
  let skin = skinToggle.getSkin(skinQueryParam && skinQueryParam[1])
    if (skin === 'walmart') {
    return includeWalmartFooter()
  } else if (skin === 'sams') {
    return includeSamsFooter()
  } else if (skin === 'walmartonline') {
    return includeWalmartOnlineFooter()    
  } else {
      // default skin is samsclub
    return includeSamsFooter()
  }
}

function includeWalmartFooter () {
  return (
    <footer>
      <div className='footer-links content-container'>
        <a target='blank' href='https://www.walmart.com/cservice/cu_comments_online.gsp?cu_heading=8' title='Contact us'>Contact us</a>
        <a target='blank' href='https://help.walmart.com/app/answers/detail/a_id/8'>Terms</a>
        <a target='blank' href='http://corporate.walmart.com/privacy-security/walmart-privacy-policy?sourceid=walmart.com-footer'>Privacy</a>
        <a target='blank' href='http://walmartstores.com/9243.aspx#California'>California privacy policy</a>
      </div>
      <div className='footer-copyright content-container'>
        <p>
        &copy; 2017 Wal-Mart Stores, Inc. All rights reserved.
      </p>
      </div>
    </footer>
  )
}

function includeWalmartOnlineFooter () {
  let footerSecureStyle = {
    paddingLeft: '20px'
  }

  let footerFontStyle = {
    fontSize:'12px'
  }  

  return (
<footer>
  <div className="footer-links content-container"><a>© Walmart Stores, Inc.</a></div>
  <div style={footerFontStyle}>
    <div className="footer-secure">
      <div style={footerSecureStyle}></div>
      <p>Secure</p>
    </div>
  </div>
</footer>
  )
}

function includeSamsFooter () {
  return (
    <footer>
      <div className='footer-links content-container'>
        <a target='blank' href='http://help.samsclub.com/app/answers/detail/a_id/167?xid=ftr_pdp-reserve_contact-us' title='Contact us'>Contact us</a>
        <a target='blank' href='http://www.samsclub.com/sams/pagedetails/content.jsp?pageName=terms-and-conditions&xid=ftr_pdp-reserve_terms-and-conditions'>Terms</a>
        <a target='blank' href='http://corporate.samsclub.com/sams-club-privacy-policy?xid=ftr_pdp-reserve_privacy-policy'>Privacy</a>
        <a target='blank' href='http://corporate.samsclub.com/sams-club-privacy-policy/california-privacy-rights?xid=ftr_pdp-reserve_california-privacy-rights'>California privacy policy</a>
      </div>
      <div className='footer-copyright content-container'>
        <p>
        &copy; 2000-2017 Sam's West, Inc. All rights reserved.
      </p>
      </div>
    </footer>
  )
}

export const Footer = () => (
  toggleFooter()
)

export default Footer



// WEBPACK FOOTER //
// ./src/layouts/skin/footer/footer.js